import Vue from 'vue'
import config from '@/config'
import axios from 'axios'
import alertHelper from '@/helpers/alert'
import paymentHelper from '@/helpers/payment'

const state = {
	data: []
}

const getters = {
  get: (state) => {
    return state.data
  }
}

const actions = {
  async generate(context, { start, end }) {
    try {
      const selectedHouse = context.rootGetters['HouseList/getSelectedHouse']

      if (start && end && selectedHouse.id) {
        await axios.post(
          config.apiBaseUrl + 'payment/downloadMultiplePDF',
          { house_id: selectedHouse.id, start_date: start, end_date: end },
          { responseType: 'blob' }
        ).then((response) => {
          paymentHelper.outputPdfAtNewTab(response, 'report.pdf')
        })

        context.dispatch('getReports')
      } else {
        alertHelper.error('Please enter a start and end date')
      }
    } catch(error) {
      alertHelper.error(error)
    }
  },
  async getReports(context) {
    try {
      const selectedHouse = context.rootGetters['HouseList/getSelectedHouse']

      if (selectedHouse.id) {
        const response = await axios.get(
          config.apiBaseUrl + 'payment_report_history',
          {
            params: { house_id: selectedHouse.id }
          }
        )

        if (response.data.errno === 0) {
          context.commit('set', response.data.data)
        } else {
          alertHelper.error(response.data.errmsg)
        }
      }
    } catch (error) {
      alertHelper.error(error)
    }
  },
  async delete(context, id) {
    try {
      const response = await axios.delete(
        config.apiBaseUrl + 'payment_report_history/' + id
      )

      if (response.data.errno === 0) {
        context.commit('delete', id)
        alertHelper.success('Successfully deleted the generated report')
      } else {
        alertHelper.error(response.data.errmsg)
      }
    } catch (error) {
      alertHelper.error(error)
    }
  }
}

const mutations = {
  set(state, data) {
    Vue.set(state, 'data', data)
  },
  delete(state, id) {
    const index = state.data.findIndex(report => report.id === id)
    state.data.splice(index, 1)
  }
}

const storeModule = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations,
}

export default storeModule
